module.exports = __webpack_public_path__ + "static/media/2.Power triller.8d63535a.jpg";